import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=8a71c8f0&scoped=true&"
import script from "./LoginHeader.vue?vue&type=script&lang=js&"
export * from "./LoginHeader.vue?vue&type=script&lang=js&"
import style0 from "./LoginHeader.vue?vue&type=style&index=0&id=8a71c8f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a71c8f0",
  null
  
)

export default component.exports